/*
* Check if the customer need the board individual, panelized tab routed
* or panelized v-scored
*/
import React          from 'react';
import RadioComponent from 'pu-react/components/RadioComponent';
import HiddenInput    from 'pu-react/components//HiddenInput';

class HasArray extends React.Component {
  // eslint-disable-next-line no-unused-vars
  componentDidUpdate(prevProps, prevState, snapshot) {
    // spacing options change on select tab rout or scoring
    // trigger validate if on of this parameters change
    if (prevProps.parameters.has_array !== this.props.parameters.has_array || prevProps.parameters.tab_rout !== this.props.parameters.tab_rout || prevProps.parameters.scoring !== this.props.parameters.scoring) {
      if (jQuery('label.error:visible').length) {
        vfIsValidForQuote('#quote_form', false)
      }
    }
  }

  render() {
    // const name = 'has_array';
    const { parameters, onChangeParameter } = this.props
    // const onChange = e => this.props.onChangeParameter(name, e.target.value);
    return (
      <div className="has-array-section itv">
        <strong className="title">I would like to receive my PCBs as</strong>
        <div className="row g-0 has-array">
          <div className="col-12">
            <RadioComponent
              name="has_array_temp"
              label="Individual Boards"
              value="0"
              checked={this.props.parameters.has_array === '0'}
              onChange={e => onChangeParameter('has_array', e.target.value)}
              className="individually"
              inputClassName="has-array-no"
              inputId="has-array-no"
              groupName={this.props.groupName} />
            <HiddenInput name="has_array" value={this.props.parameters.has_array} groupName={this.props.groupName} />
          </div>
          <div className="col-sm-6 col-lg-12 col-xl-6">
            <RadioComponent
              name="tab_route_panels"
              label="Tab Routed Panels"
              value="1"
              checked={parameters.has_array === '1' && parameters.tab_rout === '1'}
              onChange={() => onChangeParameter('tab_route_panels', '1')}
              className="tab-routed-panel"
              inputClassName="has-array-yes-tab-route"
              inputId="has-array-yes-tab-route"
              groupName={this.props.groupName} />
          </div>
          <div className="col-sm-6 col-lg-12 col-xl-6 ps-xl-2 ">
            <RadioComponent
              name="v_score_panels"
              label="V-Scored Panels"
              value="1"
              checked={parameters.has_array === '1' && parameters.scoring === '1'}
              onChange={() => onChangeParameter('v_score_panels', '1')}
              className="v-scored-panels"
              inputClassName="has-array-yes-scoring"
              inputId="has-array-yes-scoring"
              groupName={this.props.groupName} />
          </div>
        </div>
      </div>
    )
  }
}

HasArray.defaultProps = {};

export default HasArray;
